import { useState } from 'react';
import { s } from '../constants/styles';
import { exportData } from '../utils/data';

export default function SettingsView({ data, settings, onSave, onReset, onOpenProgramEditor, onChangeSplit, onImport, appVersion }) {
  const [crStr, setCrStr] = useState(String(settings.compoundRest || 180));
  const [irStr, setIrStr] = useState(String(settings.isolationRest || 90));
  const [confirm, setConfirm] = useState(false);
  const [saved, setSaved] = useState(false);

  return (
    <div className="fade-in" style={{ padding: 20, paddingBottom: 100 }}>
      <h2 style={{ fontSize: 20, fontWeight: 800, marginBottom: 16 }}>Settings</h2>

      {/* Program section */}
      <div style={{ ...s.label, marginBottom: 8 }}>PROGRAM</div>
      <div style={{ borderRadius: 14, overflow: "hidden", border: "1px solid rgba(255,255,255,0.06)", marginBottom: 24 }}>
        <button onClick={onOpenProgramEditor} style={{
          width: "100%", padding: "15px 18px", fontSize: 14, fontWeight: 700, border: "none", cursor: "pointer", fontFamily: "inherit",
          background: "var(--bg-2)", color: "var(--text-1)", display: "flex", justifyContent: "space-between", alignItems: "center",
          borderBottom: "1px solid rgba(255,255,255,0.05)",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ fontSize: 15 }}>✏️</span>
            <span>Edit Exercises</span>
          </div>
          <span style={{ color: "var(--text-3)", fontSize: 16 }}>›</span>
        </button>
        <button onClick={onChangeSplit} style={{
          width: "100%", padding: "15px 18px", fontSize: 14, fontWeight: 700, border: "none", cursor: "pointer", fontFamily: "inherit",
          background: "var(--bg-2)", color: "var(--text-1)", display: "flex", justifyContent: "space-between", alignItems: "center",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ fontSize: 15 }}>🔄</span>
            <span>Change Split</span>
          </div>
          <span style={{ color: "var(--text-3)", fontSize: 16 }}>›</span>
        </button>
      </div>

      <div style={{ marginBottom: 16 }}>
        <div style={s.label}>COMPOUND REST (SEC)</div>
        <input type="number" inputMode="numeric" value={crStr} onChange={e => setCrStr(e.target.value)} onBlur={() => { if (!crStr) setCrStr("180"); }} style={{ ...s.inp, fontSize: 18 }} />
      </div>
      <div style={{ marginBottom: 20 }}>
        <div style={s.label}>ISOLATION REST (SEC)</div>
        <input type="number" inputMode="numeric" value={irStr} onChange={e => setIrStr(e.target.value)} onBlur={() => { if (!irStr) setIrStr("90"); }} style={{ ...s.inp, fontSize: 18 }} />
      </div>
      <button onClick={() => {
        onSave({ compoundRest: Number(crStr) || 180, isolationRest: Number(irStr) || 90 });
        setSaved(true);
        setTimeout(() => setSaved(false), 2000);
      }} style={{ ...s.btnP, width: "100%", height: 50, fontSize: 15, fontFamily: "inherit", marginBottom: 12 }}>
        {saved ? "✓ Saved" : "Save Settings"}
      </button>

      {/* Export */}
      <button onClick={() => exportData(data)} style={{
        width: "100%", height: 50, borderRadius: 14, fontSize: 15, fontWeight: 700, border: "none", cursor: "pointer", fontFamily: "inherit",
        background: "rgba(52,211,153,0.08)", color: "var(--green)", border: "1px solid rgba(52,211,153,0.15)", marginBottom: 8,
      }}>
        Export Backup (JSON)
      </button>

      {/* Import */}
      <label style={{
        display: "block", width: "100%", height: 50, borderRadius: 14, fontSize: 15, fontWeight: 700,
        background: "rgba(79,143,255,0.08)", color: "var(--accent)", border: "1px solid rgba(79,143,255,0.15)",
        cursor: "pointer", textAlign: "center", lineHeight: "50px", marginBottom: 28,
      }}>
        Import Backup (JSON)
        <input type="file" accept=".json" style={{ display: "none" }} onChange={e => {
          const file = e.target.files?.[0];
          if (!file) return;
          const reader = new FileReader();
          reader.onload = evt => {
            try {
              const parsed = JSON.parse(evt.target.result);
              if (parsed.sessions) {
                onImport(parsed);
                alert("Backup restored successfully.");
              } else {
                alert("Invalid backup file.");
              }
            } catch { alert("Could not read file."); }
          };
          reader.readAsText(file);
          e.target.value = "";
        }} />
      </label>

      <div style={{ borderTop: "1px solid rgba(255,255,255,0.05)", paddingTop: 20 }}>
        {!confirm ? (
          <button onClick={() => setConfirm(true)} style={{ width: "100%", padding: "14px 0", borderRadius: 14, fontSize: 14, fontWeight: 700, border: "none", cursor: "pointer", fontFamily: "inherit", background: "var(--red-dim)", color: "var(--red)" }}>
            Reset All Data
          </button>
        ) : (
          <div>
            <p style={{ fontSize: 14, color: "var(--red)", textAlign: "center", marginBottom: 10 }}>Delete all history?</p>
            <div style={{ display: "flex", gap: 8 }}>
              <button onClick={() => setConfirm(false)} style={{ ...s.btnG, flex: 1, padding: "14px 0", fontSize: 14, fontFamily: "inherit" }}>Cancel</button>
              <button onClick={() => { onReset(); setConfirm(false); }} style={{ ...s.btnP, flex: 1, padding: "14px 0", fontSize: 14, fontFamily: "inherit", background: "linear-gradient(135deg, #ef4444, #dc2626)" }}>Confirm</button>
            </div>
          </div>
        )}
      </div>

      <div style={{ textAlign: "center", paddingTop: 16 }}>
        <span style={{ fontSize: 11, color: "var(--text-3)", fontWeight: 600 }}>Gymingify v{appVersion}</span>
      </div>
    </div>
  );
}
